// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__31_e5","label":"CategoryService_label__2nwNY","location":"CategoryService_location__bczjW"};